import { Icon, useActive, useAttrs } from "@remirror/react";
import { useLinkState } from "../../hooks/useLinkState";
import { FloatingToolbar } from "@remirror/react-ui";
import "./FloatingLinkToolbar.css";
import { trimUrlForDisplay } from "./trimUrlForDisplay";

type Props = {
  nodeId: string;
};

export function FloatingLinkToolbar({ nodeId }: Props) {
  const { isEditing } = useLinkState(nodeId);
  const active = useActive();
  const activeLink = active.link();
  const url = (useAttrs().link()?.href as string) ?? "";
  // Clean up URL for display by removing https:// and www. prefixes
  // e.g. https://www.monday.com -> monday.com
  const trimmedUrlForDisplayOnly = trimUrlForDisplay(url);

  const openLinkContainer = (
    <div className="open-link-wrapper">
      <Icon name="link" size={16} />
      Open
      <a className="truncate-text" href={url} target="_blank" rel="noreferrer">
        {trimmedUrlForDisplayOnly}
      </a>
    </div>
  );

  return (
    <>
      {!isEditing && activeLink && (
        <FloatingToolbar>{openLinkContainer}</FloatingToolbar>
      )}
    </>
  );
}
